export default __webpack_public_path__ + "static/media/banner3.35f9885b.jpg";